<div class="leads-table-container">
	<div class="top-bar">
		<div class="search-bar">
			<app-search-control [control]="searchControl" placeholder="Search"></app-search-control>
			<button type="button" class="btn btn-sm btn-primary" [routerLink]="ClientLeadsRoutes.CREATE">
				<i class="bi bi-plus"> </i>
				New
			</button>
		</div>

		<app-dropdown-control
			[clearable]="true"
			[formGroup]="form"
			[multiple]="true"
			[options]="leadStatusOptions"
			name="leadStatus"
			placeholder="Filter by status"
		/>

		<app-radio-group-control [formGroup]="form" [options]="leadRequestTypeOptions" name="leadRequestType" />
	</div>

	<div class="content">
		<div class="section table-container">
			<div class="table-headings">
				<div class="column-name long">Client Name</div>
				<div class="column-name long">Service</div>
				<div class="column-name short">Status</div>
			</div>

			<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
			<ng-template #loadedContent>
				<ng-container *ngIf="leads.length === 0; else leadsTable">
					<div class="table-row">
						<div class="inner-row">
							<em class="fw-bold">
								No
								{{ leadStatus.value.join(', ') | titlecase }}
								leads.
							</em>
						</div>
					</div>
				</ng-container>
				<ng-template #leadsTable>
					<ng-container *ngFor="let lead of leads">
						<div
							class="table-row"
							(click)="onLeadItemClick(lead)"
							(keyup.enter)="onLeadItemClick(lead)"
							tabindex="0"
							role="button"
						>
							<div class="inner-row long">{{ lead.personalDetails.name | nullDefault: 'N/A' }}</div>
							<div class="inner-row long">
								{{ lead?.onSiteVisitAssessment?.serviceType | nullDefault: '-' }}
							</div>
							<div class="inner-row short">
								<app-lead-status-badge [status]="lead.status"></app-lead-status-badge>
							</div>
						</div>
					</ng-container>
				</ng-template>
			</ng-template>
		</div>
	</div>
</div>
